import { NavLink } from "react-router-dom";
import { Trash2 } from "lucide-react";
import { Button } from "./ui/button";
import { cancelBookingIsAvailable } from "@/utils/booking";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "./ui/table";
import { ClassesTableProps } from "../@types/props.types";
import { formatDate, formatTime } from "@/utils/dateFormatters";

const ClassesTable = ({
  appointments,
  clubNames,
  onClickDeleteClasses,
  userName,
}: ClassesTableProps) => {
  if (appointments.length === 0) {
    return (
      <div className="flex h-full items-center justify-center rounded-lg border p-6">
        <span className="text-center text-sm text-gray-500">
          Активных занятий нет. Вы можете записаться на занятие в разделе{" "}
          <NavLink to="/sign-up">
            <span className="text-[#4ab0dd]">Расписание</span>
          </NavLink>
        </span>
      </div>
    );
  }

  return (
    <div className="mb-6 w-full">
      <div className="overflow-hidden rounded-lg border bg-white shadow-sm">
        <div className="border-b">
          <Table>
            <TableHeader>
              <TableRow className="bg-gray-50/75 hover:bg-transparent">
                <TableHead className="w-[25%] px-2 py-3 text-center font-medium text-gray-600">
                  Дата
                </TableHead>
                <TableHead className="w-[25%] px-2 py-3 text-center font-medium text-gray-600">
                  Тренер / ребенок
                </TableHead>
                <TableHead className="w-[50%] px-2 py-3 text-center font-medium text-gray-600">
                  Филиал
                </TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {appointments.map((classItem, index) => (
                <TableRow key={index} className="transition-colors hover:bg-gray-50/75">
                  <TableCell className="px-2 py-3">
                    <div className="text-center text-sm font-medium">
                      {formatDate(classItem.start_date)}
                    </div>
                    <div className="text-center text-xs text-muted-foreground">
                      {formatTime(classItem.start_date)}
                    </div>
                  </TableCell>
                  <TableCell className="px-2 py-3 text-center text-sm">
                    {classItem.employee?.name + " " + "/" + " " + userName}
                  </TableCell>
                  <TableCell className="px-2 py-3">
                    <div className="flex flex-col items-center gap-2">
                      <span className="text-center text-sm">{clubNames[classItem.club_id]}</span>
                      {cancelBookingIsAvailable(classItem.start_date) ? (
                        <Button
                          variant="ghost"
                          size="sm"
                          className="h-8 text-red-500 hover:bg-red-50 hover:text-red-600"
                          onClick={() => onClickDeleteClasses(classItem.appointment_id)}
                        >
                          <Trash2 className="mr-2 h-4 w-4" />
                          Отменить
                        </Button>
                      ) : (
                        <div className="text-center text-sm text-gray-500">
                          Отмена недоступна после 18:00
                        </div>
                      )}
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  );
};

export default ClassesTable;
